export interface AnimeItem {
  id: string;
  slug: string;
  title: string;
  cover: string;
  categories: string[];
  rating: number;
  status: string;
  updateChapter: string;
  updateTime: string;
  description: string;
  author: string;
  views: number;
  tags: string[];
  year: number;
  region: string;
  totalChapters: number;
}

export const categories = [
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line', count: 1280 },
  { slug: 'guoman', name: '国漫', icon: 'ri-flag-2-line', count: 960 },
  { slug: 'hanman', name: '韩漫', icon: 'ri-star-line', count: 540 },
  { slug: 'shaonian', name: '少年热血', icon: 'ri-fire-line', count: 720 },
  { slug: 'xuanhuan', name: '玄幻奇幻', icon: 'ri-magic-line', count: 450 },
  { slug: 'aiqing', name: '恋爱校园', icon: 'ri-heart-line', count: 380 },
  { slug: 'xiju', name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: 320 },
  { slug: 'xuanyi', name: '悬疑推理', icon: 'ri-search-eye-line', count: 210 },
  { slug: 'kehuan', name: '科幻未来', icon: 'ri-rocket-line', count: 180 },
  { slug: 'zhanji', name: '战斗冒险', icon: 'ri-sword-line', count: 290 },
];

export const animeList: AnimeItem[] = [
  {
    id: '1',
    slug: 'guimaizhiren-wuxianlieche',
    title: '鬼灭之刃：无限列车篇',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20art%20of%20demon%20slayer%20inspired%20warrior%20with%20flaming%20sword%20on%20train%20at%20night%2C%20dramatic%20lighting%2C%20Japanese%20aesthetic%2C%20vibrant%20colors%2C%20cinematic%20composition&width=600&height=800&seq=anime-cover-01&orientation=portrait',
    categories: ['日漫', '少年热血', '战斗冒险'],
    rating: 9.7,
    status: '已完结',
    updateChapter: '第52话',
    updateTime: '2025-12-20',
    description: '时值日本大正时期，卖炭少年炭治郎的平凡生活在家人惨遭恶鬼袭击的那一天发生了剧变。为了寻找能让妹妹祢豆子变回人类的方法，他踏上了成为"鬼杀队"一员的道路。无限列车篇讲述了炭治郎与炎柱炼狱杏寿郎在无限列车上的激烈战斗。',
    author: '吾峠呼世晴',
    views: 12800000,
    tags: ['热血', '战斗', '少年', '鬼怪', '日本'],
    year: 2020,
    region: '日本',
    totalChapters: 52,
  },
  {
    id: '2',
    slug: 'quanzhiren-tianxia',
    title: '全职猎人：天下第一',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20of%20young%20adventurer%20in%20green%20outfit%20with%20fishing%20rod%2C%20fantasy%20world%20background%2C%20mysterious%20aura%2C%20manga%20art%20style%2C%20clean%20illustration&width=600&height=800&seq=anime-cover-02&orientation=portrait',
    categories: ['日漫', '少年热血', '战斗冒险'],
    rating: 9.5,
    status: '连载中',
    updateChapter: '第400话',
    updateTime: '2026-01-05',
    description: '小杰为了寻找失踪的父亲，踏上了成为猎人的旅程。猎人是一种拥有特殊资格的人，他们可以自由探索世界的各个角落。在旅途中，小杰结识了奇犽、酷拉皮卡和雷欧力，四人一起面对无数艰难挑战。',
    author: '富坚义博',
    views: 15600000,
    tags: ['冒险', '热血', '友情', '少年', '幻想'],
    year: 2011,
    region: '日本',
    totalChapters: 400,
  },
  {
    id: '3',
    slug: 'yirenzhixia-zuiqiang',
    title: '一人之下：最强异人',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20poster%20of%20young%20man%20with%20supernatural%20powers%2C%20martial%20arts%20pose%2C%20modern%20urban%20setting%2C%20mystical%20energy%20effects%2C%20oriental%20aesthetic%2C%20dynamic%20composition&width=600&height=800&seq=anime-cover-03&orientation=portrait',
    categories: ['国漫', '玄幻奇幻', '战斗冒险'],
    rating: 9.4,
    status: '连载中',
    updateChapter: '第550话',
    updateTime: '2026-01-08',
    description: '普通大学生张楚岚因为爷爷的失踪而卷入异人世界的纷争，在结识冯宝宝后，他逐渐揭开了爷爷身死的真相和甲申之乱的秘密，同时也发现了自身潜藏的强大力量。',
    author: '米二',
    views: 9800000,
    tags: ['国漫', '异能', '都市', '热血', '悬疑'],
    year: 2018,
    region: '中国',
    totalChapters: 550,
  },
  {
    id: '4',
    slug: 'shenyin-gongzhu',
    title: '神隐公主：千年之恋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20poster%20of%20beautiful%20princess%20in%20traditional%20hanbok%20dress%2C%20magical%20forest%20setting%2C%20romantic%20atmosphere%2C%20soft%20pastel%20colors%2C%20ethereal%20lighting%2C%20elegant%20illustration&width=600&height=800&seq=anime-cover-04&orientation=portrait',
    categories: ['韩漫', '恋爱校园', '玄幻奇幻'],
    rating: 9.2,
    status: '连载中',
    updateChapter: '第89话',
    updateTime: '2026-01-10',
    description: '被诅咒的公主在沉睡千年后苏醒，发现世界已经天翻地覆。为了解开诅咒，她必须在现代世界中找到前世的爱人，而那个人却不记得她。一场跨越千年的爱恋就此展开。',
    author: '金秀贤',
    views: 6500000,
    tags: ['恋爱', '奇幻', '穿越', '宫廷', '浪漫'],
    year: 2023,
    region: '韩国',
    totalChapters: 89,
  },
  {
    id: '5',
    slug: 'zhufeng-xunxianji',
    title: '诛风寻仙记',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%20of%20swordsman%20in%20flowing%20white%20robes%20riding%20a%20sword%20through%20clouds%2C%20ancient%20Chinese%20landscape%2C%20mystical%20mountains%2C%20celestial%20light%2C%20elegant%20brushwork%20style&width=600&height=800&seq=anime-cover-05&orientation=portrait',
    categories: ['国漫', '玄幻奇幻'],
    rating: 9.3,
    status: '连载中',
    updateChapter: '第320话',
    updateTime: '2026-01-06',
    description: '少年林凡偶然获得上古仙人的传承，从此踏上修仙之路。在这个仙魔并立的宏大世界里，他凭借坚定的道心和过人的天赋，一步步从凡人成长为名震三界的绝世强者。',
    author: '天蚕土豆',
    views: 11200000,
    tags: ['修仙', '国漫', '玄幻', '热血', '成长'],
    year: 2020,
    region: '中国',
    totalChapters: 320,
  },
  {
    id: '6',
    slug: 'richang-gaoxiaojun',
    title: '日常搞笑君',
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20slice%20of%20life%20anime%20poster%20with%20group%20of%20school%20students%20having%20fun%20in%20classroom%2C%20colorful%20and%20playful%20art%20style%2C%20bright%20sunny%20day%2C%20exaggerated%20expressions%2C%20clean%20illustration&width=600&height=800&seq=anime-cover-06&orientation=portrait',
    categories: ['日漫', '搞笑日常'],
    rating: 9.0,
    status: '连载中',
    updateChapter: '第150话',
    updateTime: '2026-01-09',
    description: '平凡的高中生田中每天过着普通到不能再普通的生活，直到班上转来了一个自称来自外星的女生。从此，田中的日常生活变得鸡飞狗跳，各种令人捧腹的搞笑事件接连不断。',
    author: '青山刚',
    views: 7200000,
    tags: ['搞笑', '日常', '校园', '轻松', '治愈'],
    year: 2021,
    region: '日本',
    totalChapters: 150,
  },
  {
    id: '7',
    slug: 'zhentan-xueyuan',
    title: '侦探学园：迷案录',
    cover: 'https://readdy.ai/api/search-image?query=Mystery%20anime%20poster%20of%20detective%20student%20in%20dark%20academy%20setting%2C%20magnifying%20glass%2C%20mysterious%20shadows%2C%20Gothic%20architecture%2C%20suspenseful%20atmosphere%2C%20film%20noir%20inspired%20illustration&width=600&height=800&seq=anime-cover-07&orientation=portrait',
    categories: ['日漫', '悬疑推理'],
    rating: 9.1,
    status: '连载中',
    updateChapter: '第78话',
    updateTime: '2026-01-07',
    description: '天才高中生侦探林默被特招进入全国最顶尖的侦探学园，在这里每个学生都是推理高手。一桩桩离奇案件接连发生，林默凭借超强的逻辑推理能力，逐步揭开隐藏在学园深处的惊天秘密。',
    author: '黑岩勉',
    views: 5800000,
    tags: ['推理', '悬疑', '校园', '侦探', '烧脑'],
    year: 2022,
    region: '日本',
    totalChapters: 78,
  },
  {
    id: '8',
    slug: 'xinghe-diguo',
    title: '星河帝国：机械觉醒',
    cover: 'https://readdy.ai/api/search-image?query=Sci%20fi%20mecha%20anime%20poster%20of%20giant%20robot%20in%20space%20battle%2C%20futuristic%20cityscape%2C%20neon%20lights%2C%20starfield%20background%2C%20dramatic%20space%20opera%20style%2C%20sleek%20mechanical%20design&width=600&height=800&seq=anime-cover-08&orientation=portrait',
    categories: ['日漫', '科幻未来'],
    rating: 9.0,
    status: '已完结',
    updateChapter: '第96话',
    updateTime: '2025-11-15',
    description: '公元2350年，人类已经遍布银河系。少年驾驶员翔在一场星际战争中失去了家园，却意外觉醒了与远古机械文明共鸣的能力。他驾驶着传说中的机甲"星核"，为了守护剩下的人类而战斗。',
    author: '石川雅之',
    views: 8900000,
    tags: ['科幻', '机甲', '宇宙', '战争', '冒险'],
    year: 2019,
    region: '日本',
    totalChapters: 96,
  },
  {
    id: '9',
    slug: 'moshou-xueyuan',
    title: '魔兽学院：天赋觉醒',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20academy%20anime%20poster%20with%20students%20summoning%20magical%20creatures%2C%20grand%20castle%20school%2C%20magical%20effects%2C%20adventure%20theme%2C%20vibrant%20colorful%20art%20style%2C%20epic%20fantasy%20illustration&width=600&height=800&seq=anime-cover-09&orientation=portrait',
    categories: ['韩漫', '玄幻奇幻', '少年热血'],
    rating: 8.9,
    status: '连载中',
    updateChapter: '第112话',
    updateTime: '2026-01-04',
    description: '在一个以魔兽为核心的世界里，少年辰逸觉醒了传说中的双系天赋。进入魔兽学院后，他从最底层开始，凭借不懈努力和过人智慧，一步步征服强大的魔兽，向着最强魔兽使的目标前进。',
    author: '李东焕',
    views: 7100000,
    tags: ['魔兽', '校园', '成长', '冒险', '热血'],
    year: 2022,
    region: '韩国',
    totalChapters: 112,
  },
  {
    id: '10',
    slug: 'tianshi-yu-e-mo',
    title: '天使与恶魔的秘密',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20anime%20poster%20of%20angel%20and%20demon%20facing%20each%20other%2C%20ethereal%20light%20vs%20dark%20shadows%2C%20feathers%20and%20wings%2C%20soft%20dramatic%20lighting%2C%20beautiful%20contrast%2C%20emotional%20illustration&width=600&height=800&seq=anime-cover-10&orientation=portrait',
    categories: ['日漫', '恋爱校园'],
    rating: 8.8,
    status: '已完结',
    updateChapter: '第66话',
    updateTime: '2025-10-30',
    description: '天使学院的优等生莉莉安被派往人间执行任务，却意外与恶魔之子坠入爱河。天界与魔界的千年恩怨、禁忌之恋的挣扎、两界的战争，她将如何抉择？',
    author: '渡边纱织',
    views: 6200000,
    tags: ['恋爱', '天使', '恶魔', '奇幻', '校园'],
    year: 2021,
    region: '日本',
    totalChapters: 66,
  },
  {
    id: '11',
    slug: 'chuanyue-huoxian',
    title: '穿越火线：异世争锋',
    cover: 'https://readdy.ai/api/search-image?query=Action%20anime%20poster%20of%20warrior%20with%20modern%20weapons%20in%20fantasy%20world%2C%20explosion%20effects%2C%20dynamic%20battle%20pose%2C%20cross%20between%20military%20and%20fantasy%2C%20intense%20atmosphere%2C%20cinematic%20illustration&width=600&height=800&seq=anime-cover-11&orientation=portrait',
    categories: ['国漫', '战斗冒险', '科幻未来'],
    rating: 8.7,
    status: '连载中',
    updateChapter: '第245话',
    updateTime: '2026-01-03',
    description: '特种兵王穿越到异世界，凭借现代军事技能在魔法世界中闯出一片天地。他组建军团、建立根据地，用现代战术对抗传统魔法，创造了一段传奇般的征战史诗。',
    author: '辰东',
    views: 8400000,
    tags: ['穿越', '军事', '异世界', '战斗', '策略'],
    year: 2022,
    region: '中国',
    totalChapters: 245,
  },
  {
    id: '12',
    slug: 'shiyue-xinyang',
    title: '十月新阳：青春物语',
    cover: 'https://readdy.ai/api/search-image?query=Slice%20of%20life%20anime%20poster%20of%20teenagers%20under%20cherry%20blossom%20trees%2C%20school%20uniforms%2C%20spring%20atmosphere%2C%20warm%20sunlight%2C%20gentle%20and%20nostalgic%20mood%2C%20beautiful%20pastel%20illustration&width=600&height=800&seq=anime-cover-12&orientation=portrait',
    categories: ['日漫', '恋爱校园', '搞笑日常'],
    rating: 8.6,
    status: '连载中',
    updateChapter: '第88话',
    updateTime: '2026-01-02',
    description: '高中二年级的十月，转校生林小阳来到了一座海边小镇的学校。在这里，他遇到了性格各异的同学们，一起度过了充满欢笑、泪水和成长的珍贵青春时光。',
    author: '新海诚',
    views: 4500000,
    tags: ['青春', '校园', '日常', '治愈', '成长'],
    year: 2023,
    region: '日本',
    totalChapters: 88,
  },
];

export const featuredAnime = animeList.filter((a) => a.rating >= 9.2);

export const latestUpdates = [...animeList].sort((a, b) =>
  new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()
);

export const rankingByViews = [...animeList].sort((a, b) => b.views - a.views);

export const rankingByRating = [...animeList].sort((a, b) => b.rating - a.rating);

export const bannerAnime = animeList.filter((a) => a.rating >= 9.3);

export const faqs = [
  {
    question: '51动漫网是什么？',
    answer: '51动漫网是一个专业的免费动漫在线阅读平台，汇集了日漫、国漫、韩漫等各类热门动漫资源。我们致力于为动漫爱好者提供高清流畅的阅读体验和丰富多样的动漫内容选择。',
  },
  {
    question: '51动漫网需要注册才能观看吗？',
    answer: '不需要。51动漫网秉承免费开放的理念，所有动漫资源均可免费在线阅读，无需注册登录，点击即可畅享阅读体验。',
  },
  {
    question: '51动漫网站和51动漫官网有什么区别？',
    answer: '51动漫网站和51动漫官网均指同一个平台——51动漫网官方主页。通过任一入口访问，您都能享受到相同的优质动漫内容和服务。',
  },
  {
    question: '51动漫网支持哪些设备观看？',
    answer: '51动漫网全面支持电脑、平板和手机等多种设备浏览。我们采用响应式设计，确保在不同屏幕尺寸下都能获得最佳的阅读体验，让您随时随地畅享动漫乐趣。',
  },
  {
    question: '51动漫网的更新频率如何？',
    answer: '51动漫网每日更新大量动漫资源，热门连载作品保持与官方同步更新，确保您能第一时间追到最新的动漫章节。同时我们也持续扩充动漫库，为您带来更多精彩的动漫内容。',
  },
  {
    question: '如何在51动漫网上找到想看的动漫？',
    answer: '您可以通过首页的分类导航、搜索功能或排行榜快速找到心仪的动漫。我们提供日漫、国漫、韩漫等多种分类，以及热门推荐、最新更新和人气排行等频道，帮助您轻松发现感兴趣的动漫作品。',
  },
];